import { SITE_URL, SITE_NAME, DEFAULT_IMAGE } from './Seo';

export { SITE_URL, SITE_NAME, DEFAULT_IMAGE };

const ORG = {
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: DEFAULT_IMAGE,
};

export const orgSchema = () => ({
    '@context': 'https://schema.org',
    ...ORG,
    sameAs: [],
});

export const websiteSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}/?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
    },
});

export const breadcrumbSchema = (items) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, idx) => ({
        '@type': 'ListItem',
        position: idx + 1,
        name: it.name,
        item: `${SITE_URL}${it.path}`,
    })),
});

export const softwareAppSchema = ({ name, description, path }) => ({
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    url: `${SITE_URL}${path}`,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Any (browser-based)',
    browserRequirements: 'Requires JavaScript and a modern browser (Chrome, Firefox, Edge, Safari).',
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    publisher: ORG,
});

export const howToSchema = ({ name, description, steps }) => ({
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name,
    description,
    step: steps.map((text, i) => ({
        '@type': 'HowToStep',
        position: i + 1,
        name: `Step ${i + 1}`,
        text,
    })),
});

export const faqSchema = (items) => ({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(({ q, a }) => ({
        '@type': 'Question',
        name: q,
        acceptedAnswer: { '@type': 'Answer', text: a },
    })),
});

export const articleSchema = ({ title, description, slug, date, image = DEFAULT_IMAGE }) => {
    const url = `${SITE_URL}/blog/${slug}`;
    return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: title,
        description,
        image,
        author: ORG,
        publisher: { ...ORG, logo: { '@type': 'ImageObject', url: DEFAULT_IMAGE } },
        datePublished: date,
        dateModified: date,
        mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    };
};
